// extracted by mini-css-extract-plugin
export default {"active":"AdminLayout_active__9GO75","fadeIn":"AdminLayout_fadeIn__Zcvo6"};